// Work-center picker data (spec 01 §4 S4: "work center picker, facility-filtered").
// Work centers are owned by Module 16 (/v1/org/work-centers), not the catalogue
// module, so this local hook sits with the routing editor rather than in the
// shared catalogue-queries file. Facility filtering is done server-side via the
// query param — a facility-scoped principal only ever sees its own work centers.
//
// The response carries optional cost fields (labor/overhead rate — redactable per
// §7); this screen never reads or renders them, so no cost surface exists here.

import { useQuery } from "@tanstack/react-query";
import { client } from "../../../../../lib/api";
import { unwrap } from "../../../../../lib/request";

export function useWorkCenters(facilityId: string) {
  return useQuery({
    queryKey: ["org", "work-centers", facilityId],
    retry: false,
    enabled: facilityId.length > 0,
    queryFn: async ({ signal }) =>
      unwrap(
        await client.GET("/v1/org/work-centers", {
          signal,
          params: { query: { facility_id: facilityId, status: "active" } },
        }),
        "work-centers",
      ),
  });
}
